import { Link } from 'react-router-dom'
import { FaCircle } from 'react-icons/fa'
import { NumericFormat } from 'react-number-format'
import { DealsChart } from 'components/Contact/Contact/common/DealsChart'
import { SocialMedia } from 'components/common/SocialMedia'
import isEmpty from 'lodash/isEmpty'
import s from './CompanyInfoSection.scss'
import { getCurrency } from 'utils/authService'
import pluralize from 'pluralize'

const CompanyInfoSection = ({ company, companyPipeline, companyPage }) => {
  const { totalDeals, totalValue } = companyPipeline

  const {
    id,
    name,
    shortName,
    address,
    city,
    state,
    zipcode,
    logo,
    facebook,
    twitter,
    linkedin,
    instagram,
    type,
    numberOfContacts
  } = company

  return (
    <section className={s.main}>
      <div className={s.generalInfo}>
        {logo && (
          <div className={s.logoContainer}>
            <img src={logo} />
          </div>
        )}
        {!companyPage && (
          <>
            <div className={s.infoItem}>
              Legal Name: {name}
              <FaCircle className={s.circle} />
              <Link className={s.link} to={`/companies/${id}`}>
                View company profile
              </Link>
            </div>
            <div className={s.socialMedia}>
              <SocialMedia
                facebook={facebook}
                twitter={twitter}
                linkedin={linkedin}
                instagram={instagram}
              />
            </div>
            {shortName && <div className={s.infoItem}>Short Name: {shortName}</div>}
            {(address || city || state || zipcode) && (
              <div className={s.infoItem}>
                Location: {address ? `${address}, ` : ''}
                {city} {state} {zipcode}
              </div>
            )}
            {type && <div className={s.infoItem}>Company Type: {company.type.name}</div>}
            {numberOfContacts && (
              <div className={s.infoItem}># of contacts in iDeal CRM: {numberOfContacts}</div>
            )}
          </>
        )}
      </div>
      <section className={s.chartContainer}>
        <div className={s.title}>
          TOTAL CURRENT PIPELINE: {pluralize('opportunity', totalDeals || 0, true)}
          <FaCircle className={s.circle} />
          <NumericFormat
            displayType="text"
            thousandSeparator
            value={totalValue}
            prefix={getCurrency().symbol}
          />
        </div>
        {!isEmpty(companyPipeline) && (
          <DealsChart chartWidth={320} chartHeight={420} pipeline={companyPipeline} />
        )}
      </section>
    </section>
  )
}

export default CompanyInfoSection
